import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react"
import PropTypes from "prop-types"
import { Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { setPage, setTotalPage } from "store/paginate/actions"
import numeral from "numeral"

const Paginate = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  // const { page, totalPage } = useSelector(state => ({
  //   page: state.Paginate.page,
  //   totalPage: state.Paginate.totalPage,
  // }))

  const {
    page,
    totalPage,
    pageSize,
    onPageChange,
    dataList,
    onSetPage,
    onSetTotalPage,
  } = props

  useEffect(() => {}, [])

  useEffect(() => {
    if (!props.globalTotalPage) {
      onSetTotalPage(Math.ceil(dataList.length / pageSize))
    }
  }, [dataList])

  useEffect(() => {
    if (totalPage !== 0 && page > totalPage) {
      onSetPage(totalPage)
    }
  }, [totalPage])

  useEffect(() => {
    onPageChange(page)
  }, [page])

  useImperativeHandle(ref, () => ({
    getPage: () => page,
    resetPage: () => {
      // dispatch(setPage(1))
    },
  }))

  return (
    <>
      {totalPage > 0 && (
        <Pagination className="pagination justify-content-end mt-3 mb-0">
          <PaginationItem disabled={page === 1}>
            <PaginationLink
              previous
              onClick={() => onSetPage(page - 1)}
              disabled={props.loading}
            />
          </PaginationItem>

          {Array.from({ length: totalPage }, (_, i) => i + 1).map(value =>
            value === 1 ||
            value === totalPage ||
            value === page ||
            value === page - 1 ||
            value === page + 1 ? (
              <PaginationItem active={value === page} key={value}>
                <PaginationLink
                  onClick={() => onSetPage(value)}
                  disabled={props.loading}
                >
                  {numeral(value).format("0,0")}
                </PaginationLink>
              </PaginationItem>
            ) : (value === page - 2 && value - 1 > 0) ||
              (value === page + 2 && totalPage - value > 0) ? (
              <PaginationItem disabled key={value}>
                <PaginationLink disabled={props.loading}>. . .</PaginationLink>
              </PaginationItem>
            ) : null
          )}

          <PaginationItem disabled={page === totalPage}>
            <PaginationLink
              next
              onClick={() => onSetPage(page + 1)}
              disabled={props.loading}
            />
          </PaginationItem>
        </Pagination>
      )}
    </>
  )
})

Paginate.displayName = "Paginate"

Paginate.propTypes = {
  page: PropTypes.number,
  totalPage: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onSetPage: PropTypes.func,
  onSetTotalPage: PropTypes.func,
  dataList: PropTypes.array,
  globalTotalPage: PropTypes.bool,
  loading: PropTypes.bool,
}

export default Paginate
